import { render, staticRenderFns } from "./zx-tag.vue?vue&type=template&id=1ac92a4e&scoped=true&"
import script from "./zx-tag.vue?vue&type=script&lang=js&"
export * from "./zx-tag.vue?vue&type=script&lang=js&"
import style0 from "./zx-tag.vue?vue&type=style&index=0&id=1ac92a4e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac92a4e",
  null
  
)

export default component.exports